import { getSuppliersBasicInfo } from "../../../../ApiCalls/mantisFlowsSuppliers";
import { getOrderItems, getQuotationItemsByOrderId } from "../../../../ApiCalls/mantisFlowsManangment";

export const loadSuppliers = async (clientId, setSuppliers, setSuppliersError, setIsLoadingSuppliers, suppliersLoadedRef) => {
  if (suppliersLoadedRef.current) {
    console.log("Proveedores ya cargados anteriormente, usando datos en memoria");
    return;
  }

  suppliersLoadedRef.current = true;

  if (!clientId) {
    console.error("No se puede cargar proveedores: client_id es undefined");
    setSuppliersError("ID de cliente no disponible");
    setIsLoadingSuppliers(false);
    return;
  }

  console.log("Cargando proveedores para cliente:", clientId);
  setIsLoadingSuppliers(true);

  try {
    const timestamp = new Date().getTime();
    const response = await getSuppliersBasicInfo(clientId, timestamp);
    console.log("Respuesta de proveedores:", response);

    if (response && response.success && Array.isArray(response.data)) {
      const formattedSuppliers = response.data.map(supplier => ({
        id: supplier.id,
        name: supplier.name,
        country: supplier.country,
        email: supplier.contact_email,
        phone: supplier.phone,
        address: supplier.address,
        currency: supplier.currency,
        rating: supplier.rating_overall || 0,
        rating_service: supplier.rating_service || 0,
        rating_punctuality: supplier.rating_punctuality || 0,
        rating_quality: supplier.rating_quality || 0,
        is_favorite: supplier.is_favorite || false,
        description: supplier.description,
        capabilities: Array.isArray(supplier.capabilities) ? supplier.capabilities : [],
        typicalLeadTime: supplier.typicalleadtime
      }));

      console.log("Proveedores formateados:", formattedSuppliers);
      setSuppliers(formattedSuppliers);
    } else {
      console.error("Formato de respuesta incorrecto:", response);
      setSuppliersError('No se pudieron cargar los proveedores correctamente');
      suppliersLoadedRef.current = false;
    }
  } catch (error) {
    console.error('Error al cargar proveedores:', error);
    setSuppliersError(error.message || 'Error al cargar los proveedores');
    suppliersLoadedRef.current = false;
  } finally {
    setIsLoadingSuppliers(false);
  }
};

export const handleSupplierSelection = async (
  supplierId,
  data,
  setSelectedSupplierId,
  setSelectedCsSupplierId,
  selectedStep,
  addLog
) => {
  try {
    setSelectedSupplierId(supplierId);
    
    if (selectedStep === "Quotations") {
      setSelectedCsSupplierId(supplierId);
    }

    localStorage.setItem(
      `selected_supplier_${data?.order_id}`,
      JSON.stringify({
        supplierId,
        timestamp: new Date().getTime()
      })
    );

    if (addLog) {
      addLog(`Selected supplier: ${supplierId}`, "info", selectedStep);
    }

    return true;
  } catch (error) {
    console.error("Error selecting supplier:", error);
    return false;
  }
};

export const loadQuotationItems = async (
  clientId,
  orderId,
  setAllQuotationItems,
  setIsLoadingAllQuotations,
  toast
) => {
  if (!clientId || !orderId) {
      console.log("Datos insuficientes para cargar quotation items:", {
        clientId,
        orderId
      });
    return [];
  }

  try {
    setIsLoadingAllQuotations(true);
    console.log("Cargando quotation items para orden:", {
      clientId,
      orderId
    });

    const items = await getQuotationItemsByOrderId(clientId, orderId);
    console.log("Quotation items cargados:", items);
    
    // Los items ya vienen con supplier_id del backend
    setAllQuotationItems(items || []);
    return items || [];
    
  } catch (error) {
    console.error("Error loading quotation items:", error);
    if (toast) {
      toast({
        title: "Error",
        description: "Failed to load quotation items",
        variant: "destructive"
      });
    }
    return [];
  } finally {
    setIsLoadingAllQuotations(false);
  }
};

export const saveQuotationData = (
  supplierId,
  supplier,
  quotationItems,
  data,
  addLog
) => {
  try {
    if (supplier && quotationItems.length > 0) {
      const selectedSupplierItems = quotationItems.filter(
        item => item.supplier_id === supplierId
      );

      const totalAmount = selectedSupplierItems.reduce(
        (sum, item) => sum + (parseFloat(item.unit_price || 0) * (item.quantity || 0)),
        0
      );

      localStorage.setItem(
        `po_data_${data?.order_id}`,
        JSON.stringify({
          supplierId: supplier.id,
          supplierName: supplier.name,
          items: selectedSupplierItems,
          totalAmount: totalAmount
        })
      );

      if (addLog) {
        addLog(`Saved quotation data for supplier: ${supplier.name}`, "success", "Quotation");
      }

      return true;
    }
    return false;
  } catch (error) {
    console.error("Error saving quotation data:", error);
    return false;
  }
}; 